// ============================================
// FILE 4: /frontend/src/api/discovery.api.js
// PURPOSE: Discovery API endpoints
// ============================================

import apiClient from './client.js';

export const discoveryAPI = {
  // Get similar listings
  getSimilarListings: async (listingId, limit = 5) => {
    const response = await apiClient.get(`/discovery/similar/${listingId}?limit=${limit}`);
    return response.data;
  },

  // Apply quick filter
  applyQuickFilter: async (filterType, category = null) => {
    const response = await apiClient.post('/discovery/filter', {
      filterType,
      category,
    });
    return response.data;
  },
};